import React from 'react';
import Sidebar from './AdminSidebar';

const WarehouseUserSettings = ({ userId, activePage }) => {
  return <Sidebar userId={userId} activePage={activePage} />;
};

export default WarehouseUserSettings;
